

import {  useState } from "react";
import '../pages/SettingPageuser.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import {  toast } from "react-toastify";
import { loginSuccessF } from "../redux/slices/farmsSlice";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import apiService from "../api/ApiService";
import { useForm } from "react-hook-form";
import { Close, Fax, Female, Home, ImportContacts, LocationOn, MobileFriendly, Person, Phone } from "@mui/icons-material";
const moment=require('moment-jalaali');


const CreateNewFarm=()=>{
    const {currentFarms}=useSelector(state=>state.farms)
    
    const {isOpenModal,closeModalls,openModalls}=useGlobalContext();
    const dispatch=useDispatch()
    const {
       
        register,
        handleSubmit,
        formState: { errors }
      } = useForm();

    const createFarm=async(data)=>{
       
        const data1={...data,ownerGender:+data?.ownerGender}
        console.log(data1)
                const res=await apiService.addNewFarm(JSON.stringify(data1));
                dispatch(loginSuccessF([...currentFarms,res.data]))
                openModalls()
            }
        
    
    

    return <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <form onSubmit={handleSubmit(createFarm)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
                <AddToPhotosIcon fontSize="large"/>
           
            <h4 >      ایجاد دامداری جدید</h4>
            </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("name",{required:true})}/>
            <label for="" className={'labelSS'}><Home fontSize='small'/> نام مزرعه</label>
            {errors.name&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("ownerName",{required:true})}/>
            <label for="" className={'labelSS'}><Person fontSize="small"/> نام و نام خانوادگی مالک</label>
            {errors.ownerName&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        
 
        <div style={{display:'flex',gap:'5px'}}>
        
        <div className='inputContainerSS' style={{width:'135px'}}>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("fax",{required:true})}/>
            <label for="" className={'labelSS'}><Fax fontSize="small"/> فکس</label>
            {errors.fax&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        <div className='inputContainerSS' style={{width:'135px'}}>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("phone",{required:true})}/>
            <label for="" className={'labelSS'}><Phone fontSize="small"/> تلفن مزرعه</label>
            {errors.phone&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("ownerPhone",{required:'این مقدار ضروری است',pattern:{
                value:/^09\d{9}$/,
                message:'شماره وارد شده معتبر نیست'
            }})}/>
            <label for="" className={'labelSS'}><MobileFriendly fontSize="small"/> موبایل مالک</label>
            {errors?.ownerPhone?.message&&<span className='errMsg'>{errors.ownerPhone.message}</span>}
        </div>
        <div style={{display:'flex',gap:'5px'}}>
        <div className='inputContainerSS' style={{width:'135px'}}>
            <input step="any" autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("longitude",{required:true})}/>
            <label for="" className={'labelSS'}><LocationOn fontSize="small"/>  long</label>
            {errors.longitude&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        <div className='inputContainerSS' style={{width:'135px'}}>
            <input step="any" autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("latitude",{required:true})}/>
            <label for="" className={'labelSS'}><LocationOn fontSize="small"/>  lat</label>
            {errors.latitude&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        </div>
        <div className='inputContainerSS'>
            <textarea autoComplete="off" type="text"  className='inputSS inputSSText' placeholder="a" {...register("address",{required:true})}/>
            <label for="" className={'labelSS labelText'}><ImportContacts fontSize="small"/> نشانی</label>
            {errors.address&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        
        <div className="SelConn" >
        <label for='sele' ><Female fontSize="small"/> جنسیت:</label>
        <select id='sele' name='sele' className="selectInp"{...register("ownerGender",{required:true})}>
            
            <option value={0}>
                مرد
            </option>
            <option value={1}>
                زن
            </option>
        </select>
        {errors.ownerGender&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        <button className="EditMOdalBtnForm" type="submit">
            افزودن
        </button>
        </form>
        
    </div>
}
export default CreateNewFarm